import { createIfpApplication } from '@sec-loans-ui/common/api/endpoints'
import { IfpCreateApplicationRequest, IfpCreateApplicationResponse } from '@shared/sec-loans'

import { createNewApplicationMachine } from '../newApplicationMachine'

export type NewIfpApplicationMachineType = ReturnType<
  typeof createNewApplicationMachine<IfpCreateApplicationRequest, IfpCreateApplicationResponse>
>
export const createNewIfpApplicationMachine = (): NewIfpApplicationMachineType =>
  createNewApplicationMachine('newIfpApplicationMachine', createIfpApplication)
